import React, { Component } from "react";
import {
  Container,
  Button,
  ModalBody,
  Modal,
  Input,
  Col,
  Row,
} from "reactstrap";

import ErrorTokenMiss from "../ErrorTokenMiss/ErrorTokenMiss";
import LoadingOverlay from "react-loading-overlay";
import RequestManager from "../../singletons/RequestManager/RequestManager";
export default class OrderItemInactive extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tokenMissmatchModalVisible: false,
      tokenErrorMessage: "",
      price: "",
      spinnerLoading: false,
    };
  }

  componentDidMount() {
    //cartItem.node.stock.
    console.log("props", this.props.item);
  }
  render() {
    let item = this.props.item;
    const { spinnerLoading } = this.state;
    return (
      <LoadingOverlay
        style={{ width: "100%", height: "100%", zIndex: 999 }}
        active={spinnerLoading === true ? true : false}
        spinner
        text="Loading ..."
      >
        <Container
          fluid
          style={{ padding: 0, margin: 0, alignItems: "center" }}
        >
          <Modal
            size="lg"
            isOpen={this.state.tokenMissmatchModalVisible}
            toggle={this.toggleErrorTokenMissModal}
          >
            <ErrorTokenMiss
              editable={true}
              tokenErrorMessage={this.state.tokenErrorMessage}
              goBack={this.toggleErrorTokenMissModal}
            />
          </Modal>
          <ModalBody>
            <div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  marginBottom: 15,
                  paddingBottom: 10,
                  borderBottom: "1px solid #ECECEC",
                }}
              >
                <p>{"Are you sure, Do Not Sell This Item"} </p>

                <Button
                  style={{ color: "white", backgroundColor: "red" }}
                  onClick={this.props.goBack}
                >
                  {" "}
                  Back
                </Button>
              </div>
              <div>
                <p> {item.node.stock.referenceName}</p>

                <Row
                  xs="12"
                  style={{
                    margin: 10,
                    display: "flex",
                    flex: 1,
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Col
                    xs="12"
                    style={{
                      display: "flex",
                      flex: 1,
                      flexDirection: "row",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <Button
                      color={"primary"}
                      onClick={() => {
                        this.updateStock();
                      }}
                    >
                      {"Submit"}
                    </Button>
                  </Col>
                </Row>
              </div>
            </div>
          </ModalBody>
        </Container>
      </LoadingOverlay>
    );
  }
  handlePriceChange = (event) => {
    this.setState({ price: event.target.value });
  };

  toggleErrorTokenMissModal = (text) => {
    this.setState({
      tokenMissmatchModalVisible: !this.state.tokenMissmatchModalVisible,
      tokenErrorMessage: text,
    });
  };

  updateStock = async () => {
    this.setState({ spinnerLoading: true });
    let requestManager = new RequestManager();
    let item = this.props.item;

    let params = {
      input: {
        id: item.node.stock.id,
        status: "INACTIVE",
      },
    };

    console.log("params", JSON.stringify(params));
    let response = await requestManager.getResponseFromPredefinedQuery(
      "updateStock",
      params
    );
    if (response.error === null) {
      console.log("updateStock", JSON.stringify(response));
      this.props.goBack();
    } else {
      this.setState({ spinnerLoading: false });
      alert(
        "Unable to update inventory. Please check your internet connection."
      );
    }
  };
  updateSkuPrice = async () => {
    this.setState({ spinnerLoading: true });
    let requestManager = new RequestManager();
    let stock = this.props.stock;
    let price = this.state.price;
    let params = {
      input: {
        id: stock.node.sku.id,
        maximumRetailPrice: parseFloat(price),
      },
    };

    console.log("params", JSON.stringify(params));
    let response = await requestManager.getResponseFromPredefinedQuery(
      "updateSku",
      params
    );
    if (response.error === null) {
      this.setState({ spinnerLoading: false });
      console.log("updateSku", JSON.stringify(response));

      this.props.refreshInventory();
      this.props.goBack();
    } else {
      this.setState({ spinnerLoading: false });
      alert(
        "Unable to update inventory. Please check your internet connection."
      );
    }
  };
}



// WEBPACK FOOTER //
// ./src/components/DetailedOrderCard/OrderItemInactive.js